var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.64V5.17C11 2.59067 8.98404 0.5 6.50004 0.5C4.01604 0.5 2.00004 2.59067 2.00004 5.17V5.64C2.00084 6.20104 1.84074 6.75053 1.53871 7.22333L0.800041 8.37333C0.126041 9.42333 0.640708 10.8507 1.81337 11.1827C4.87757 12.0504 8.12252 12.0504 11.1867 11.1827C12.3594 10.8507 12.874 9.42333 12.2 8.374L11.4614 7.224C11.1591 6.75127 10.9988 6.20177 10.9994 5.64067L11 5.64Z",
    stroke: "#082B72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.834C3.93667 12.9993 5.11467 13.834 6.5 13.834C7.88533 13.834 9.06333 12.9993 9.5 11.834",
    stroke: "#082B72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.7fd11f18de5a7d344dbb21abaf358b17.svg";
export { ForwardRef as ReactComponent };